export default "__VITE_ASSET__CYzt$ogH__"